"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
var _sliceInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/slice");
var _reverseInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/reverse");
var _Promise2 = require("@babel/runtime-corejs3/core-js-stable/promise");
var _Object$setPrototypeOf = require("@babel/runtime-corejs3/core-js-stable/object/set-prototype-of");
var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");
var _Object$getPrototypeOf = require("@babel/runtime-corejs3/core-js-stable/object/get-prototype-of");
var _Object$create = require("@babel/runtime-corejs3/core-js-stable/object/create");
var _Symbol = require("@babel/runtime-corejs3/core-js-stable/symbol");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.print = exports.download = exports.deleteDoc = exports.closePreview = exports.appendIframe = void 0;
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.promise.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/web.url.js");
require("core-js/modules/web.url-search-params.js");
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var _url = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/url"));
var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _splice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/splice"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));
var _emitEvents = require("../utils/emit-events");
var _document = require("./services/document");
function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = _Object$defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof _Symbol ? _Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return _Object$defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = _Object$create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = _Object$getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = _Object$create(IteratorPrototype); function defineIteratorMethods(prototype) { var _context10; _forEachInstanceProperty(_context10 = ["next", "throw", "return"]).call(_context10, function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], _forEachInstanceProperty(tryLocsList).call(tryLocsList, pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return _Object$setPrototypeOf ? _Object$setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = _Object$create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = _Promise2); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return _reverseInstanceProperty(keys).call(keys), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { var _context11; if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, _forEachInstanceProperty(_context11 = this.tryEntries).call(_context11, resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+_sliceInstanceProperty(name).call(name, 1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
var closePreview = function closePreview(ctx) {
  (0, _emitEvents.emit)(ctx, 'closePreview', true);
};
exports.closePreview = closePreview;
var iframeCleanup = function iframeCleanup(ctx) {
  var iframe = ctx.shadowRoot.querySelector('#previewActionIframe');
  if (iframe) {
    ctx.shadowRoot.removeChild(iframe);
  }
};
var deleteDoc = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(ctx) {
    var _context;
    var file;
    return _regeneratorRuntime().wrap(function _callee$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          file = ctx.previewItems[ctx.currentIndex].document;
          (0, _emitEvents.emit)(ctx, 'headerButtonClick', {
            type: 'delete',
            file: file
          });
          (0, _splice.default)(_context = ctx.previewItems).call(_context, ctx.currentIndex, 1);
          if (ctx.currentIndex === ctx.previewItems.length && ctx.currentIndex > 0) {
            ctx.prevDoc();
          } else if (ctx.currentIndex < ctx.previewItems.length) {
            ctx.currentIndex--;
            ctx.nextDoc();
          } else {
            closePreview(ctx);
          }
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee);
  }));
  return function deleteDoc(_x) {
    return _ref.apply(this, arguments);
  };
}();
exports.deleteDoc = deleteDoc;
var download = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(ctx) {
    var file, _ctx$previewItems$ctx, url, token, downloadUrlResponse, downloadObject;
    return _regeneratorRuntime().wrap(function _callee2$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          iframeCleanup(ctx);
          if (!(ctx.documentType !== 'object' || ctx.emitHeaderButtonClicks)) {
            _context3.next = 5;
            break;
          }
          file = ctx.previewItems[ctx.currentIndex].document;
          (0, _emitEvents.emit)(ctx, 'headerButtonClick', {
            type: 'download',
            file: file
          });
          return _context3.abrupt("return");
        case 5:
          ctx.actionLoading = true;
          _context3.prev = 6;
          _ctx$previewItems$ctx = ctx.previewItems[ctx.currentIndex], url = _ctx$previewItems$ctx.url, token = _ctx$previewItems$ctx.token;
          _context3.next = 10;
          return (0, _document.getDownloadUrl)(url, ctx, token);
        case 10:
          downloadUrlResponse = _context3.sent;
          if (!downloadUrlResponse) {
            _context3.next = 18;
            break;
          }
          url = downloadUrlResponse.data;
          url = url.replace(/^https?:\/\/(\w+\.?)+:443/, '');
          url = "".concat(url, "&att=1");
          downloadObject = {
            url: url,
            name: ctx.previewItems[ctx.currentIndex].name,
            crossOrigin: true
          };
          _context3.next = 21;
          break;
        case 18:
          _context3.next = 20;
          return downloadAsObject(ctx.previewItems[ctx.currentIndex]);
        case 20:
          downloadObject = _context3.sent;
        case 21:
          if (!isIOS(navigator.userAgent)) {
            _context3.next = 25;
            break;
          }
          downloadInNewTab(url, false);
          _context3.next = 27;
          break;
        case 25:
          _context3.next = 27;
          return performDownload(ctx, downloadObject);
        case 27:
          ctx.actionLoading = false;
          ctx.requestUpdate();
          _context3.next = 36;
          break;
        case 31:
          _context3.prev = 31;
          _context3.t0 = _context3["catch"](6);
          ctx.actionLoading = false;
          ctx.requestUpdate();
          (0, _emitEvents.emit)(ctx, 'error', {
            type: 'download',
            msg: "Unable to download ".concat(ctx.documentName, ". Please try again.")
          });
        case 36:
        case "end":
          return _context3.stop();
      }
    }, _callee2, null, [[6, 31]]);
  }));
  return function download(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
exports.download = download;
var browserPrint = function browserPrint(frame, ctx) {
  try {
    if (frame.contentDocument) {
      frame.contentWindow.focus();
      return frame.contentWindow.print();
    }
    ctx.actionLoading = false;
    (0, _emitEvents.emit)(ctx, 'error', {
      type: 'print',
      msg: "Printing of this file type is not supported in this Internet browser. Download the document, or switch to a different browser to print."
    });
    return false;
  } catch (_) {
    ctx.actionLoading = false;
    (0, _emitEvents.emit)(ctx, 'error', {
      type: 'print',
      msg: "Unable to print ".concat(ctx.documentName, ". Please try again.")
    });
  }
};
var print = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(ctx) {
    var _context4, file, _context5, convertToPdf, url, printIframe, append;
    return _regeneratorRuntime().wrap(function _callee4$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          iframeCleanup(ctx);
          if (!(ctx.documentType !== 'object' || ctx.emitHeaderButtonClicks)) {
            _context7.next = 5;
            break;
          }
          file = (0, _find.default)(_context4 = ctx.previewItems).call(_context4, function (item) {
            return item.index === ctx.currentIndex;
          }).document;
          (0, _emitEvents.emit)(ctx, 'headerButtonClick', {
            type: 'print',
            file: file
          });
          return _context7.abrupt("return");
        case 5:
          ctx.actionLoading = true;
          _context7.prev = 6;
          convertToPdf = true;
          if ((0, _indexOf.default)(_context5 = ctx.previewItems[ctx.currentIndex].mimeType).call(_context5, 'image/') === 0) {
            convertToPdf = false;
          }
          _context7.next = 11;
          return (0, _document.getDownloadUrl)(ctx.previewItems[ctx.currentIndex].url, ctx, ctx.previewItems[ctx.currentIndex].token, convertToPdf);
        case 11:
          url = _context7.sent;
          url = url.data;
          url = url.replace(/^https?:\/\/(\w+\.?)+:443/, '');
          if (isIOS(navigator.userAgent)) {
            downloadInNewTab(url, true);
          } else {
            printIframe = document.createElement('iframe');
            printIframe.id = 'previewActionIframe';
            printIframe.src = url;
            append = ctx.shadowRoot.append || ctx.shadowRoot.appendChild;
            append.call(ctx.shadowRoot, printIframe);
            printIframe.addEventListener('load', /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
              return _regeneratorRuntime().wrap(function _callee3$(_context6) {
                while (1) switch (_context6.prev = _context6.next) {
                  case 0:
                    browserPrint(ctx.shadowRoot.querySelector('#previewActionIframe'), ctx);
                  case 1:
                  case "end":
                    return _context6.stop();
                }
              }, _callee3);
            })));
          }
          ctx.actionLoading = false;
          _context7.next = 22;
          break;
        case 18:
          _context7.prev = 18;
          _context7.t0 = _context7["catch"](6);
          ctx.actionLoading = false;
          (0, _emitEvents.emit)(ctx, 'error', {
            type: 'print',
            msg: "Unable to print ".concat(ctx.documentName, ". Please try again.")
          });
        case 22:
        case "end":
          return _context7.stop();
      }
    }, _callee4, null, [[6, 18]]);
  }));
  return function print(_x3) {
    return _ref3.apply(this, arguments);
  };
}();
exports.print = print;
var downloadInNewTab = function downloadInNewTab(url, print) {
  var iosDownloadWindow = window.open(url, '_blank');
  if (print && iosDownloadWindow) {
    iosDownloadWindow.addEventListener('load', function () {
      (0, _setTimeout2.default)(function () {
        iosDownloadWindow.print();
      });
    });
  }
};
var downloadAsObject = /*#__PURE__*/function () {
  var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(item) {
    var documentResponse, documentLocalUrl;
    return _regeneratorRuntime().wrap(function _callee5$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return fetch(item.url, {
            method: 'GET',
            headers: {
              'Content-Type': '*/*'
            }
          });
        case 2:
          documentResponse = _context8.sent;
          _context8.t0 = _url.default;
          _context8.next = 6;
          return documentResponse.blob();
        case 6:
          _context8.t1 = _context8.sent;
          documentLocalUrl = _context8.t0.createObjectURL.call(_context8.t0, _context8.t1);
          return _context8.abrupt("return", {
            name: extractFilename(documentResponse.headers.get('content-disposition') || '', item.name),
            url: documentLocalUrl,
            crossOrigin: false,
            dispose: function dispose() {
              return _url.default.revokeObjectURL(documentLocalUrl);
            }
          });
        case 9:
        case "end":
          return _context8.stop();
      }
    }, _callee5);
  }));
  return function downloadAsObject(_x4) {
    return _ref5.apply(this, arguments);
  };
}();
var extractFilename = function extractFilename(contentDisposition, fallbackName) {
  try {
    var matches = /filename="([^"]*)"/g.exec(contentDisposition);
    return matches.length === 2 ? matches[1] : fallbackName;
  } catch (_unused) {
    return fallbackName;
  }
};
var performDownload = /*#__PURE__*/function () {
  var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(ctx, download) {
    var a;
    return _regeneratorRuntime().wrap(function _callee6$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          if (download.crossOrigin) {
            appendIframe(ctx, download.url);
          } else {
            a = document.createElement('a');
            document.getElementsByTagName('body')[0].appendChild(a);
            a.style.display = 'none';
            a.href = download.url;
            a.target = '_blank';
            a.download = download.name;
            a.click();
            a.remove();
          }
          (0, _setTimeout2.default)(function () {
            return download.dispose ? download.dispose() : undefined;
          });
          return _context9.abrupt("return", _promise.default.resolve(true));
        case 3:
        case "end":
          return _context9.stop();
      }
    }, _callee6);
  }));
  return function performDownload(_x5, _x6) {
    return _ref6.apply(this, arguments);
  };
}();
var appendIframe = function appendIframe(ctx, url) {
  var downloadFrame = document.createElement('iframe');
  downloadFrame.id = 'previewActionIframe';
  downloadFrame.src = url;
  var append = ctx.shadowRoot.append || ctx.shadowRoot.appendChild;
  append.call(ctx.shadowRoot, downloadFrame);
};
exports.appendIframe = appendIframe;
var isIOS = function isIOS(userAgent) {
  return /iPhone|iPad/i.test(userAgent);
};
